export default __webpack_public_path__ + "bg_anli_nengyuan029ddc13.png";